import React, { useRef, useEffect, useState } from "react";
import {
  LocationFieldContainer,
  MainPolicyContainer,
  SubPolicyContainer,
  SubPolicyFieldContainer,
  SubPolicyModalContainer,
  SubPolicyModalHeader,
  PolicyActionButton,
  CreatePolicyContainer,
  SubPolicies,
  SelectStyles,
} from "./ModalCreatePolicy.styled";
import Close from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";
import Select from "react-select";
import { theme as themeConfig } from "../../themes/themes";
import AddSubPolicy from "../AddSubPolicy/AddSubPolicy";
import { NotificationManager } from "react-notifications";
import { COUNTRIES_BY_CLIENT } from "../../GraphQL/Queries";
import { useLazyQuery } from "@apollo/client";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import { Col, Row } from "react-bootstrap";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { ROLES } from "../../util/RolesConstants";

const ModalCreatePolicy = ({
  closeModal,
  user,
  handleSave,
  usersCountryId,
  showSavePolicyLoader,
}) => {
  const rLocation = useRef("");
  const [locationOptions, setLocationOptions] = useState([]);
  const [locationValue, setLocationValue] = useState(0);
  const [subPolicyComponent, setSubPolicyComponent] = useState([]);
  const [mainPolicy, setMainPolicy] = useState("");

  const [runQueryCountry, { loading: loadingCountries }] = useLazyQuery(
    COUNTRIES_BY_CLIENT,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfAllCountries = data.countryLocationList.map((element) => {
          return {
            value: element?.countryId,
            label: element?.countryName,
          };
        });
        setLocationOptions(resultOfAllCountries);
      },
      error: (err) => {
        NotificationManager.warning("error");
      },
    }
  );

  useEffect(() => {
    if (user?.clientId) {
      runQueryCountry({
        variables: { clientId: user.clientId },
        context: { clientName: "LinkUsers" },
      });
    }
    /* Setting User's country id for country admin role and Supervisor role */
    if (
      user.roleId === ROLES.COUNTRY_ADMIN ||
      user.roleId === ROLES.SUPERVISOR
    ) {
      setLocationValue(usersCountryId);
    }
  }, []);

  const handleAddPolicy = () => {
    let arr = [...subPolicyComponent];
    arr.unshift({
      id: arr.length,
      subPolicyName: "",
      lobIds: [],
    });
    setSubPolicyComponent(arr);
  };

  const deleteSubPolicy = (id) => {
    let arr = subPolicyComponent.filter((policy) => policy.id !== id);
    setSubPolicyComponent(arr);
  };

  const onChangeLobs = (val, id) => {
    let arr = subPolicyComponent;
    arr.forEach((policy) => {
      if (policy.id === id) {
        policy.lobIds = val;
      }
    });
    setSubPolicyComponent(arr);
  };

  const onChangePolicy = (val, id) => {
    let arr = subPolicyComponent;
    arr.forEach((policy) => {
      if (policy.id === id) {
        policy.subPolicyName = val;
      }
    });
    setSubPolicyComponent(arr);
  };

  const validateMandatoryFields = () => {
    let error = false;
    if (mainPolicy.trim() === "") {
      error = true;
    }
    if (subPolicyComponent.length > 0) {
      subPolicyComponent.forEach((policy) => {
        if (policy.subPolicyName === "" || policy.lobIds.length === 0) {
          error = true;
        }
      });
    } else {
      error = true;
    }
    return error;
  };

  const onSaveClick = () => {
    const hasError = validateMandatoryFields();
    if (hasError) {
      NotificationManager.warning("Please fill all the manadatory fields");
    } else {
      const subPolicies = subPolicyComponent.map((data) => {
        return {
          subPolicyName: data.subPolicyName,
          lobIds: data.lobIds.map((data) => {
            return parseInt(data.value);
          }),
        };
      });

      const data = {
        mainPolicyName: mainPolicy,
        countryId: locationValue,
        subPolicies: subPolicies,
      };
      handleSave(data);
    }
  };

  return (
    <CreatePolicyContainer>
      <SubPolicyModalContainer>
        <SubPolicyModalHeader>
          <label>Create Policy</label>
          <IconButton onClick={() => closeModal(false)}>
            <Close />
          </IconButton>
        </SubPolicyModalHeader>
        {(user.roleId === ROLES.SUPER_ADMIN || user.roleId === ROLES.GAM) && (
          <LocationFieldContainer>
            <label className="heading-label">Location</label>
            {loadingCountries ? (
              <Row>
                <Col md="12" className="d-flex justify-content-center">
                  <PointersLine color={themeConfig.text.primary} />
                </Col>
              </Row>
            ) : (
              <div className="location-dropdown">
                <Select
                  styles={SelectStyles}
                  placeholder="Select an option"
                  ref={rLocation}
                  options={locationOptions}
                  onChange={(option) => {
                    setLocationValue(option.value);
                  }}
                />
              </div>
            )}
          </LocationFieldContainer>
        )}
        <MainPolicyContainer>
          <label className="heading-label">
            Main Policy <span className="mandatory">*</span>
          </label>
          <input
            placeholder="Enter Main Policy"
            disabled={
              locationValue === 0 &&
              (user.roleId === ROLES.SUPER_ADMIN || user.roleId === ROLES.GAM)
                ? true
                : false
            }
            onChange={(val) => {
              setMainPolicy(val.target.value);
            }}
          />
        </MainPolicyContainer>
        <SubPolicyContainer>
          <SubPolicyFieldContainer>
            <button
              className="add-policy-btn"
              onClick={handleAddPolicy}
              disabled={
                locationValue === 0 &&
                (user.roleId === ROLES.SUPER_ADMIN || user.roleId === ROLES.GAM)
                  ? true
                  : false
              }
            >
              <span>+</span>
              Add Sub Policy
            </button>
          </SubPolicyFieldContainer>
          {subPolicyComponent.length > 0 && (
            <SubPolicies>
              {subPolicyComponent.map((subpolicy, index) => {
                return (
                  <AddSubPolicy
                    key={subpolicy.id}
                    id={subpolicy.id}
                    deleteSubPolicy={deleteSubPolicy}
                    lobsOnChange={onChangeLobs}
                    subPolicyOnChange={onChangePolicy}
                    countryId={locationValue}
                    index={index + 1}
                  />
                );
              })}
            </SubPolicies>
          )}
        </SubPolicyContainer>
        <PolicyActionButton>
          <button onClick={onSaveClick}>Save</button>
        </PolicyActionButton>
        {showSavePolicyLoader && <ModalLoader />}
      </SubPolicyModalContainer>
    </CreatePolicyContainer>
  );
};

export default ModalCreatePolicy;
